/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.75 13.1895V3.7482l-.0121-.1348a.7503.7503 0 0 0-.7927-.6132.75.75 0 0 0-.6952.7465c0-.0004 0 .0005 0 0v10.0638l3.9695 3.9719.1039.0868a.7502.7502 0 0 0 .9568-.0865l.0868-.1038a.7503.7503 0 0 0-.0855-.9558c.0004.0004-.0003-.0003 0 0L12.75 13.1895Zm-.8527-11.689C6.1456 1.5556 1.5 6.2353 1.5 12c0 5.799 4.701 10.5 10.5 10.5S22.5 17.799 22.5 12c0-5.7647-4.6455-10.4443-10.3972-10.4995a10.6596 10.6596 0 0 0-.2055 0ZM12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0Z"
    clipRule="evenodd"
  />,
  'Time'
);
